import { createRoot } from 'react-dom/client';

import Root from './app/Root';
import { initializeGoogleTagManager } from './app/Services/Config/googleTagManager';

initializeGoogleTagManager();

const root = createRoot(document.getElementById('app') as HTMLElement);
root.render(Root);
